import styled from '@emotion/styled';
import { Twitter } from '@mui/icons-material';
import { Outlet } from 'react-router-dom';
import Header from './Header';
import openseaLogo from 'assets/images/opensea-icon.png';

// ==============================|| MINIMAL LAYOUT ||============================== //

const MinimalLayout = () => (
  <Root>
    <Header />
    <Container>
      <Outlet />
    </Container>
    <Footer>
      <a href="https://twitter.com/OmniCatsWorld" target="_blank" rel="noreferrer">
        <Twitter sx={{ color: 'white', fontSize: '3rem' }} />
      </a>
      <a href="https://opensea.io/collection/omnicats-world" target="_blank" rel="noreferrer">
        <img src={openseaLogo} alt="open sea logo" style={{ color: 'white', height: '40px' }} />
      </a>
    </Footer>
  </Root>
);

const Footer = styled.div`
  background-color: #c20e02;
  height: 70px;
  position: absolute;
  bottom: 0px;
  left: 0px;
  right: 0px;
  margin-bottom: 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  & > * {
    margin-right: 20px;
  }
`;

const Root = styled.div`
  padding-bottom: 200px;
  position: relative;
`;

const Container = styled.div`
  width: 60%;
  margin: auto;
  margin-bottom: -50px;

  @media (max-width: 1440px) {
    width: 80%;
  }

  @media (max-width: 1024px) {
    width: 100%;
  }
`;

export default MinimalLayout;
